<template>
    <v-container class="ma-0 pa-0 steps_container" fill-height>
		<v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12" align-self="start" class="steps_title_descript mb-8">
				<p class="steps_count">7/8</p>
                다음과 같은 질병으로<br />
                <span class="steps_bolder_words">진단</span>을 받았거나, 현재<br/>
                <span class="steps_bolder_words">약물 치료</span>중이십니까?<br />
                <span class="sub-style2">* 복수 선택 가능</span>
			</v-col>
            <v-col cols="12" align-self="center" align="left">
                <ul role="listbox">
                    <li
                        tabindex="1"
                        role="listitem"
                        :class="isSelected('none') ? 'selected' : ''"
                        @click="OnClickItem('none')"
                        @keypress.enter="OnClickItem('none')"
                    >
                        해당없음
                    </li>
                    <li
                        tabindex="2"
                        role="listitem"
                        :class="isSelected('stroke') ? 'selected' : ''"
                        @click="OnClickItem('stroke')"
                        @keypress.enter="OnClickItem('stroke')"
                    >
                        뇌졸중(중풍)
                    </li>
                    <li
                        tabindex="3"
                        role="listitem"
                        :class="isSelected('hprts') ? 'selected' : ''"
                        @click="OnClickItem('hprts')"
                        @keypress.enter="OnClickItem('hprts')"
                    >
                        고혈압
                    </li>
                    <li
                        tabindex="4"
                        role="listitem"
                        :class="isSelected('heart') ? 'selected' : ''"
                        @click="OnClickItem('heart')"
                        @keypress.enter="OnClickItem('heart')"
                    >
                        심장병(심근경색/협심증)
                    </li>
                    <li
                        tabindex="5"
                        role="listitem"
                        :class="isSelected('diabml') ? 'selected' : ''"
                        @click="OnClickItem('diabml')"
                        @keypress.enter="OnClickItem('diabml')"
                    >
                        당뇨병
                    </li>
                    <li
                        tabindex="6"
                        role="listitem"
                        :class="isSelected('hplpdm') ? 'selected' : ''"
                        @click="OnClickItem('hplpdm')"
                        @keypress.enter="OnClickItem('hplpdm')"
                    >
                        고지혈증(이상지질혈증)
                    </li>
                    <li
                        tabindex="7"
                        role="listitem"
                        :class="isSelected('phss') ? 'selected' : ''"
                        @click="OnClickItem('phss')"
                        @keypress.enter="OnClickItem('phss')"
                    >
                        폐결핵
                    </li>
                    <li
                        tabindex="8"
                        role="listitem"
                        :class="isSelected('dementia') ? 'selected' : ''"
                        @click="OnClickItem('dementia')"
                        @keypress.enter="OnClickItem('dementia')"
                    >
                        치매
                    </li>
                    <li
                        tabindex="9"
                        role="listitem"
                        :class="isSelected('liver') ? 'selected' : ''"
                        @click="OnClickItem('liver')"
                        @keypress.enter="OnClickItem('liver')"
                    >
                        간암
                    </li>
                    <li
                        tabindex="10"
                        role="listitem"
                        :class="isSelected('stomach') ? 'selected' : ''"
                        @click="OnClickItem('stomach')"
                        @keypress.enter="OnClickItem('stomach')"
                    >
                        위암
                    </li>
                    <li
                        tabindex="11"
                        role="listitem"
                        :class="isSelected('colorectal') ? 'selected' : ''"
                        @click="OnClickItem('colorectal')"
                        @keypress.enter="OnClickItem('colorectal')"
                    >
                        대장암
                    </li>
                    <li
                        v-if="gender === 1"
                        tabindex="12"
                        role="listitem"
                        :class="isSelected('prostate') ? 'selected' : ''"
                        @click="OnClickItem('prostate')"
                        @keypress.enter="OnClickItem('prostate')"
                    >
                        전립선암
                    </li>
                    <li
                        v-if="gender === 2"
                        tabindex="13"
                        role="listitem"
                        :class="isSelected('breast') ? 'selected' : ''"
                        @click="OnClickItem('breast')"
                        @keypress.enter="OnClickItem('breast')"
                    >
                        유방암
                    </li>
                    <li
                        tabindex="14"
                        role="listitem"
                        :class="isSelected('lung') ? 'selected' : ''"
                        @click="OnClickItem('lung')"
                        @keypress.enter="OnClickItem('lung')"
                    >
                        폐암
                    </li>
                    <li
                        tabindex="16"
                        role="listitem"
                        :class="isSelected('etc') ? 'selected' : ''"
                        @click="OnClickItem('etc')"
                        @keypress.enter="OnClickItem('etc')"
                    >
                        기타 암
                    </li>
                </ul>
            </v-col>
		</v-row>

        <v-row dense class="ma-0 pa-0 py-4">
			<v-col cols="12" align-self="center" align="center" class="pa-0 ma-0"></v-col>
		</v-row>

        <v-container class="pa-0 ma-0 mt-5 footer_btn_group">
			<v-row class="ma-0 pa-0">
				<v-col cols="3" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						class="tearms_cancel_btn"
						block
						tabindex="8"
						@click="previous"
						tile
						v-ripple
					>
						이전
					</v-btn>
				</v-col>
				<v-col cols="9" class="ma-0 pa-0">
                    <v-btn
						elevation="0"
						block
						:class="this.enableButton ? 'tearms_start_enable_btn' : 'tearms_start_disable_btn'"
						tabindex="9"
						@click="next"
						tile
						v-ripple
					>
						다음
					</v-btn>
				</v-col>
			</v-row>
        </v-container>
    </v-container>
</template>

<script>
	import { mapActions, mapGetters } from "vuex";
	export default {
		data: () => ({
			enableButton: true,
			selectedList: []
		}),
		computed: {
			...mapGetters('survey', {
				checkUp: 'checkUp'
			}),
            ...mapGetters('user', {
                user: 'getUser'
            }),
            gender () {
			    const { user } = this
                if (!user) {
                    return 1
                }
                if (user.gender === '1') {
                    return 1
                } else {
                    return 2
                }
            },
            allChecked () {
			    const { gender } = this

			    const target = ['diabml', 'dementia', 'stomach', 'liver', 'colorectal', 'lung', 'heart', 'stroke']

                if (gender === 1) {
                    target.push('prostate')
                } else {
                    target.push('breast')
                }

			    return target.filter(item => !this.selectedList.some(item2 => item2 === item)).length === 0
            }
		},
		methods: {
			...mapActions("survey", ["setCheckupTemp", "setStep"]),
			isSelected(item) {
				if(item === 'none') {
					if(this.selectedList.length <= 0) {
						return true
					}
				}
				else {
					const index = this.selectedList.indexOf(item)
					if(index > -1) {
						return true
					}
				}
				return false
			},
			OnClickItem(item) {
				if(item === 'none') {
					this.selectedList = []
				}
				else {
					const index = this.selectedList.indexOf(item)
					if(index > -1) {
						this.selectedList.splice(index, 1)
					}
					else {
						this.selectedList.push(item)
					}
				}
			},
			previous() {
				this.setStep(9)
				this.$router.push("/checkup/step9");
			},
			next() {
				let diseaseList = this.selectedList.join(',')
				const params = {
					step: 10,
					hchk: diseaseList
				};
				this.setCheckupTemp(params);
				this.setStep(11)
				this.$router.push("/checkup/step11");
			},
			restoreData() {
				if(this.checkUp.hchk) {
					this.selectedList = this.checkUp.hchk.split(',')
				}
			}
		},
		mounted() {
            window.scrollTo(0, 0)
			this.setStep(10)
			this.restoreData()
		}
	};
</script>

<style scoped>
    .sub-style2 {
		font-family: "NanumSquare", sans-serif;
		font-weight: 700;

		font-size: 14px;
		letter-spacing: -0.35px;
		color: #202020;
		opacity: 0.5;
	}
    .title {
        min-height: 30vh;
    }
	ul li {
		display: inline-block;
		background-color: #f3f3f5;
		color: #809bb2;
		font-size: 1.05em;
		padding: 0 15px;
		margin: 0 0.4vh 0.8vh 0;
		height: 5vh;/*45px;*/
		line-height: 5vh;
		vertical-align: middle;
		border-radius: 2.5vh;
        transition: background-color 300ms, color 300ms;
	}
	ul li.selected {
		background-color: #3f6fff;
		color: white;
		font-weight: bold;
        outline: none;
	}

    ul li:focus-visible {
        outline: #1e1e1e solid 3px;
    }

	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }

	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	@media screen and (max-height: 759px)
    {   
        .intro_title_img{
            margin-top:0;
        }
    }
</style>
